import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {RegistryService} from "../../services/registry.service";

@Component({
  selector: 'app-html-widget',
  templateUrl: './html-widget.component.html',
  styleUrls: ['./html-widget.component.css']
})
export class HtmlWidgetComponent implements OnInit {

  lang='';
  constructor(private registry: RegistryService) {

    this.lang = registry.currentLang;
  }

  ngOnInit(): void {
  }

}
